// extracted by mini-css-extract-plugin
export default {"container":"cn-table_container__gCcHR","table":"cn-table_table__ZLbPc","count":"cn-table_count__OWXl2","pagination-container":"cn-table_pagination-container__eQzP4"};